import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload LCP image — browser discovers it before parsing the React tree
if (typeof window !== 'undefined') {
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/xmWWXLxxKZHbU6tdCBbPSt/mockup_(1).webp';
  preload.type = 'image/webp';
  (preload as any).fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-259" />, document.getElementById('root'));
// Defer Meta Pixel — load 5s after page load to not block anything
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      ;
      (function (f: any, b: any, e: any, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1688179945683486');
      (window as any).fbq('track', 'PageView');
    }, 5000);
  });
}